import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Segment } from '../../services/analytics-services/segment';
import Global from '../../store/global-selectors';
import { EXPERIMENT_VIEWED } from '../../constants/analytics-events';

const GROW_466 = 'GROW_466';

export const useTrackGrow466Experiment = ({ variant }) => {
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const userId = useSelector(Global.selectUserCurrentUserId);

  return useCallback(async () => {
    Segment.trackEvent(EXPERIMENT_VIEWED, {
      experiment_id: GROW_466,
      group_variation: variant,
      seller_id: sellerId,
      user_id: userId,
      enrollment_date: new Date(),
    });
  }, [sellerId, userId, variant]);
};
